<div class="admin-hub main-content no-sidebar">
  <main class="workspace" id="main-content">
    <div class="workspace-header">
      <h1>{{ pageTitle }}</h1>
      <p>{{ pageSubtitle }}</p>
    </div>

    <div class="admin-tab-panel" [attr.data-tab]="activeTab">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
